import React from 'react';
import { withTheme, DefaultTheme } from 'styled-components';
import { FjTextArea } from 'components/primitives';

type TextAreaProps = React.ComponentProps<typeof FjTextArea> & {
  theme: DefaultTheme;
};

const TextArea = ({ theme, ...otherProps }: TextAreaProps): React.JSX.Element => {
  const styleProps = {
    borderColor: theme.colors.selectableLightBg,
  };
  return <FjTextArea {...styleProps} {...otherProps} />;
};

export default withTheme(TextArea);
